import {
  GET_COMPLETED_REVIEWS_V3_REQUEST,
  GET_COMPLETED_REVIEWS_V3_RESPONSE,
  GET_COMPLETED_REVIEWS_V3_ERROR,
} from 'lib/constants/v3Actions';

const initialState = {
  isLoading: false,
  isError: false,
  reviews: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_COMPLETED_REVIEWS_V3_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case GET_COMPLETED_REVIEWS_V3_RESPONSE:
      return {
        ...state,
        isLoading: false,
        isError: false,
        isFetched: true,
        reviews: action.response.reviews,
      };
    case GET_COMPLETED_REVIEWS_V3_ERROR:
      return { ...state, isLoading: false, isError: true, reviews: [] };
    default:
      return state;
  }
};
